export default {
  download: {
    title: 'Ouverture de fichier',
    message:
      "Télécharger le fichier dans le répertoire de votre choix ou l'ouvrir ?",
    button: {
      download: 'Télécharger le fichier',
      open: 'Ouvrir le fichier',
    },
  },
}
